document.addEventListener("DOMContentLoaded", function () {
  console.log('DOMContentLoaded yg-script.js');
  
  class YGImageLoader extends HTMLElement {
    getYGImageLoader () { // TODO: 命名优化
      
      if (!this.YGImageLoader) {
        this.YGImageLoader = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const newImg = new Image();
              newImg.onload = () => {
                img.src = newImg.src;
                img.removeAttribute('data-src');  // 如果只需要加载一次
                observer.unobserve(img);          // 停止观察该元素
              }
              newImg.src = img.getAttribute('data-src');
            }
          });
        }, {
          rootMargin: "50px", // 预加载距离视口 50px 的图片
        });
      }
      return this.YGImageLoader;
    }
  }
  class YGImage extends YGImageLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getYGImageLoader) {
          this.getYGImageLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage);
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const { $popupTemplate, fn } = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {});
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }
    
    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');
      console.log($popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {}
          }
        }))
      }
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  // 公共的写在上面↑↑↑↑↑↑↑↑↑↑


  // 组件的写在下面↓↓↓↓↓↓↓↓↓↓
  class YGCardProducts extends HTMLElement {

    
    constructor() {
      super();
      this.init(); // 初始化方法
    }
    init() {
      this.initSwiper()
    }

    initSwiper() {
      // 这里放置初始化逻辑
      new Swiper(".yg-card-swiper", {
        breakpoints: { 
          320: {  //当屏幕宽度大于等于320
            slidesPerView: 2.5,
            spaceBetween: 10
          },
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 3,
            spaceBetween: 10
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 4.5,
            spaceBetween: 10
          }
        },

         scrollbar: {
          el: '.swiper-scrollbar',
        },
      
      });
    }
    
  }
  if (!window.customElements.get('yg-card-products')) {
    window.customElements.define('yg-card-products', YGCardProducts); // 自定义组件
  }

  class YGDiscount extends HTMLElement {
    constructor() {
      super()
      this.$date = this.querySelector('.product-info__discount-date')
      this.date = new Date(this.$date?.getAttribute('data-date'))
      this.timer = null
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.clickCopy()
  
      if (this.$date) {
        let date = new Date(this.$date.getAttribute('data-date'))
        this.updateCountdown()
        this.timer = setInterval(this.updateCountdown.bind(this), 1000);
      }
    }
    clickCopy() {
      // 这里放置自定义逻辑
      let $copyBtn = this.querySelector('.product-info__discount-button')
      let copyText = $copyBtn.getAttribute('data-code-text')
      let copyBtnText = $copyBtn.innerHTML
      $copyBtn.addEventListener('click', function() {
        navigator.clipboard.writeText(copyText).then(() => {
          $copyBtn.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 24L9 19L19 29L39 9L44 14L19 39L4 24Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          setTimeout(()=>{
            $copyBtn.innerHTML = copyBtnText
          }, 3000)
        }, () => {
          $copyBtn.innerHTML = '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 11L11 6L24 19L37 6L42 11L29 24L42 37L37 42L24 29L11 42L6 37L19 24L6 11Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          setTimeout(()=>{
            $copyBtn.innerHTML = copyBtnText
          }, 3000)
        });
      })
    }
  
    updateCountdown(){
      const now = new Date();
      const diff = this.date - now;
  
      if (diff <= 0) {
        this.closest('.product-info__discount').classList.add('hide')
        clearInterval(this.timer);
        return;
      }
  
      // 计算天、时、分、秒
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
  
      const countdownText = `${days}:${hours<10?'0'+hours:hours}:${minutes<10?'0'+minutes:minutes}:${seconds<10?'0'+seconds:seconds}`;
  
      this.$date.innerHTML = countdownText;
    }
  }
  if (!window.customElements.get('yg-discount')) {
    window.customElements.define('yg-discount',YGDiscount)
  }
})  